<template>
  <b-modal v-model="modalGalleryDelete" :width="550" scroll="keep">
    <div class="card">
      <div class="card-content py-5">
        <h3 class="is-size-4 has-text-weight-bold mb-5">
          ¿Estás seguro de eliminar el recurso?
        </h3>
        <hr />
        <div
          class="is-flex is-justify-content-flex-end w-full is-align-items-center"
        >
          <div>
            <Button
              variant="gray"
              @click.native="modalGalleryDelete = false"
              >Cancelar</Button
            >
          </div>
          <div class="ml-3">
            <Button
              variant="danger"
              :spinner="loading"
              @click.native="deleteGallery"
              >Sí</Button
            >
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Button from '@/components/form/Button'
import ProductService from '@/services/ProductService'
export default {
  components: {
    Button
  },
  props: {
    idGallery: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      modalGalleryDelete: true,
      loading: false
    }
  },
  watch: {
    modalGalleryDelete() {
      this.$emit('hidden')
    }
  },
  methods: {
    async deleteGallery() {
      this.loading = true
      try {
        await ProductService.deleteGalleryDetail(this.idGallery)
        this.$emit('reload')
        this.modalGalleryDelete = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'S',
          msg: 'Se eliminó correctamente.'
        })
      } catch (error) {
        this.loading = false
        this.$store.commit('settings/SET_ALERT', {
          isAlert: true,
          type: 'D',
          msg: 'Ocurrió un error.'
        })
      }
    }
  }
}
</script>
